import React from 'react';

function Statistics2511() {
  return (
    <div>
      <p>The current version of DISGENET (v25.1.1) contains:</p>
      <ul>
        <li className="bullet-item">
          <b>1,982,885</b> gene-disease associations (GDAs), between <b>29,460</b> genes and <b>42,277</b>{' '}
          diseases and phenotypes
          <ul>
            <li className="bullet-item">
              <b>6,327,878</b> evidences for GDAs, supported by <b>1,591,002</b> publications
            </li>
            <li className="bullet-item">
              <b>330,000</b> associations involving <b>13,000</b> diseases that have been detected in animal
              models
            </li>
            <li className="bullet-item">
              <b>32,278</b> GDAs are annotated with <b>14,616</b> chemicals (relating <b>13,484</b> genes and{' '}
              <b>12,821</b> diseases)
            </li>
          </ul>
        </li>
        <li className="bullet-item">
          <b>4,397,303</b> variant-disease associations (VDAs), between <b>1,425,623</b> variants and{' '}
          <b>19,067</b> diseases and phenotypes.
          <ul>
            <li className="bullet-item">
              <b>6,889,306</b> evidences for the VDAs, supported by <b>188,473</b> publications
            </li>
            <li className="bullet-item">
              <b>23,935</b> VDAs are annotated with <b>2,077</b> chemicals (relating <b>6,933</b> variants and{' '}
              <b>2,691</b> diseases)
            </li>
          </ul>
        </li>
        <li className="bullet-item">
          Over <b>28M</b> disease-disease associations.
        </li>
        <li className="bullet-item">
          This release provides annotations for <b>14,643</b> chemicals and drugs associated with GDAs and
          VDAs.
        </li>
        <li className="bullet-item">
          In total, DISGENET contains a corpus of <b>1,600,639</b> publications that support the
          genotype-phenotype associations.
        </li>
        <li className="bullet-item">
          There are <b>13,216,184</b> individual pieces of evidence in the database supporting{' '}
          <b>6,380,188</b> genotype-phenotype associations (GDAs & VDAs)
        </li>
      </ul>
    </div>
  );
}

export default Statistics2511;
